// extracted by mini-css-extract-plugin
export var link = "_r3-0";